// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Help_wrapper__1LZG-","image":"Help_image__faJ6d"};